import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  tone?: 'primary' | 'soft' | 'sun'
  full?: boolean
}

export function PrimaryButton({ children, tone = 'primary', full = true, className = '', ...props }: PrimaryButtonProps) {
  const tones = {
    primary: 'bg-garden-700 text-white shadow-button hover:bg-garden-800 active:translate-y-1 active:shadow-none',
    soft: 'bg-white text-ink border-2 border-garden-200 hover:border-garden-400',
    sun: 'bg-sun text-ink shadow-[0_7px_0_#dcae38] hover:bg-[#ffd567] active:translate-y-1 active:shadow-none',
  }
  return (
    <button
      className={`${full ? 'w-full' : ''} min-h-14 rounded-2xl px-6 py-3 text-lg font-extrabold transition-all duration-150 disabled:cursor-not-allowed disabled:opacity-50 ${tones[tone]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
